export enum SplUploadFileStatus
{
    Received = 1,
    InProcess = 2,
    Passed = 3,
    Failed = 4
}
